import { defineComponent, onMounted } from 'vue';
import PopUp from '../PopUp/PopUp.vue';
import Incentives from './Incentives/Incentives.vue';
import LeftContentContainer from './LeftContentContainer/LeftContentContainer.vue';
import ExperimentCOptInPopUp from './ExperimentCOptInPopUp.class';
import { setupIncentive } from '../incentive-base';
import RightContentContainer from './RightContentContainer/RightContentContainer.vue';
import { setupComponent } from "@studyportals/vue-platform";

export default defineComponent({
	components: {
		PopUp,
		Incentives,
		LeftContentContainer,
		RightContentContainer,
	},
	props: {
		appIdentifier: String,
	},
	setup: () => {
		const component = setupIncentive(new ExperimentCOptInPopUp());
		onMounted(component.mounted.bind(component));

		return setupComponent(component);
	},
});
